import ErrorWithCause from '@helpers/ErrorWithCause';
import axios from 'axios';
import { SYMFONY_API_BASE_URL } from '@config/apiConfig';
const getBalance = async () => {
    try {
        const response = await axios.get(`${SYMFONY_API_BASE_URL}/api/user/balance/v1`);
        return {
            PM: parseFloat(response.data.PM),
            USD: parseFloat(response.data.USD),
        };
    }
    catch (error) {
        throw new ErrorWithCause(error);
    }
};
export default getBalance;
